import React from "react";
import CategoryCard from "./CategoryCard";
import { Container, Row, Spinner } from "react-bootstrap";
import SubTitle from "../Layout/SubTitle";

const CategoryContainer = ({ AllCategories, loading }) => {
  return (
    <>
      <div className='gray-bg mt-3'>
        <Container>
          <SubTitle title="All Categories" />
        </Container>
      </div>
      <Container>
        <Row className="mt-2 mb-5 d-flex justify-content-center">
          {loading === true ? (
            <div className='d-flex justify-content-center align-items-center mt-5 pt-5 fs-20'>
              <Spinner animation="border" variant="danger" />
            </div>)
            :
            (AllCategories?.length >= 1 ?
              (AllCategories.map((item, index) => {
                return (<CategoryCard key={index} title={item.name} img={item.image} id={item._id}/>
               )
              })) : <h3 className="text-center fw-bold">No Category</h3>)
              }
        </Row>
      </Container>
    </>

  );
};

export default CategoryContainer;
